import React, { useEffect, useMemo, useState } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { Button } from "react-bootstrap";
import Modal from "react-bootstrap/Modal";
import {
  studentAddToClassAction,
  studentAddToteacherClass,
  studentListAction,
} from "../Redux/Action/studentAction";
import { useDispatch, useSelector } from "react-redux";
import SearchBar from "../Components/common/SearchBar";
import { toast } from "react-hot-toast";
import { collectionShareWithPerticulerStudentAction } from "../Redux/Action/collectionAction";
import { truncateEmail, sendVideoShareApi, getGroupFromYear } from "../Util/HelperFunction";
import { classdetailsAction } from "../Redux/Action/classAction";
import { useLocation } from "react-router-dom";
import ConfirmModal from "./ConfirmModal";

const StudentsModal = ({ show, handleClose, idval, type, collectionData }) => {
  const reduxCollectionDetails = useSelector(
    (state) => state?.collectionSlice?.collectionDetails
  );
  const currentCollection = collectionData || reduxCollectionDetails;
  const dispatch = useDispatch();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const groupString = queryParams.get("groups"); // e.g., "3,4,14"
  const [isModalOpen, setModalOpen] = useState(false);
  const [selectedType, setSelectedType] = useState(" ");
  const [searchValue, setSearchValue] = useState("");
  const [selectedGroups, setSelectedGroups] = useState([]);
  const [selectedItems, setSelectedItems] = useState([]);

  const FilterPayload = {
    searchValue: searchValue,
    selectedDepartment: "",
  };

  useEffect(() => {
    dispatch(studentListAction(FilterPayload));
  }, [searchValue]);

  const studentData = useSelector((state) => state?.studentSlice?.students);

  const getLearnerGroup = (student) => {
    if (student?.group !== undefined && student?.group !== null && student?.group !== "") {
      const g = Number(student.group);
      if (Number.isFinite(g)) return g;
    }
    if (student?.year) {
      const g = getGroupFromYear(student.year);
      if (g !== "" && Number.isFinite(Number(g))) return Number(g);
    }
    return null;
  };

  const selectedStudents = useMemo(() => {
    if (!Array.isArray(studentData?.student)) return [];
    return studentData.student.filter((s) => selectedItems.includes(s._id));
  }, [studentData, selectedItems]);

  const handleClick = (item) => {
    const isSelected = selectedItems.includes(item._id);

    if (isSelected) {
      const nextSelected = selectedItems.filter((id) => id !== item._id);
      setSelectedItems(nextSelected);
      const remainingStudents = (studentData?.student || []).filter((s) =>
        nextSelected.includes(s._id)
      );
      const remainingGroups = [
        ...new Set(
          remainingStudents
            .map(getLearnerGroup)
            .filter((g) => g !== null && Number.isFinite(g))
        ),
      ];
      setSelectedGroups(remainingGroups);
    } else {
      setSelectedItems((prev) => [...prev, item._id]);
      const g = getLearnerGroup(item);
      if (g !== null && Number.isFinite(g)) {
        setSelectedGroups((prev) => (prev.includes(g) ? prev : [...prev, g]));
      }
    }
  };

  const handleSubmit = async (idval) => {
    try {
      const Payload = {
        classId: idval,
        student: selectedItems,
      };
      const res = await dispatch(studentAddToClassAction(Payload));
      if (res?.payload?.statusCode == 200) {
        handleClose();
        dispatch(classdetailsAction(idval)).setSelectedItems([]);
        toast.success("Learner added successfully!", {
          iconTheme: {
            primary: "#4318ff",
            secondary: "#FFFAEE",
          },
        });
      } else {
        toast.error(res?.payload?.message);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleAddToTeacher = async (idval) => {
    try {
      const Payload = {
        classId: idval,
        student: selectedItems,
      };
      const res = await dispatch(studentAddToteacherClass(Payload));
      if (res?.payload?.statusCode == 200) {
        handleClose();
        setSelectedItems([]);
        toast.success("Learner added successfully!", {
          iconTheme: {
            primary: "#4318ff",
            secondary: "#FFFAEE",
          },
        });
      } else {
        toast.error(res?.payload?.message);
      }
    } catch (error) {
      console.log(error);
    }
  };


  const getVideoGroups = (video) => {
    const raw = video?.group || video?.videoId?.group || video?.groups;
    if (Array.isArray(raw)) {
      return raw.map(Number).filter(Number.isFinite);
    }
    if (typeof raw === "string" && raw.includes(",")) {
      return raw.split(",").map(Number).filter(Number.isFinite);
    }
    if (raw !== undefined && raw !== null && raw !== "") {
      const num = Number(raw);
      if (Number.isFinite(num)) return [num];
    }
    return [];
  };

  const handleShareClick = async (idval) => {
    let urlGroups = [];
    if (groupString && groupString.trim() !== "") {
      urlGroups = groupString.split(",").map(Number).filter(Number.isFinite);
    }

    const videosToCheck =
      Array.isArray(currentCollection?.video) && currentCollection.video.length > 0
        ? currentCollection.video
        : [];

    const learnerGroups = [
      ...new Set(
        selectedStudents
          .map(getLearnerGroup)
          .filter((g) => g !== null && Number.isFinite(g))
      ),
    ];

    const effectiveLearnerGroups =
      learnerGroups.length > 0
        ? learnerGroups
        : selectedGroups.map(Number).filter(Number.isFinite);

    let hasMismatch = false;

    if (videosToCheck.length > 0 && effectiveLearnerGroups.length > 0) {
      hasMismatch = effectiveLearnerGroups.some((sGroup) => {
        return videosToCheck.some((video) => {
          const vGroups = getVideoGroups(video);
          return vGroups.length > 0 && !vGroups.includes(sGroup);
        });
      });
    } else if (urlGroups.length > 0 && effectiveLearnerGroups.length > 0) {
      hasMismatch = effectiveLearnerGroups.some(
        (group) => !urlGroups.includes(Number(group))
      );
    }

    if (hasMismatch) {
      setSelectedType("sensitiveContent");
      setModalOpen(true);
    } else {
      sensitiveContentShare();
    }
  };

  const sensitiveContentShare = async () => {
    try {
      const Payload = {
        collectionId: idval,
        studentId: selectedItems,
      };

      if (currentCollection?.video && currentCollection.video.length > 0) {
        await sendVideoShareApi(currentCollection.video);
      }

      const res = await dispatch(
        collectionShareWithPerticulerStudentAction(Payload)
      );
      if (res?.payload?.statusCode == 200) {
        handleClose();
        handleConfirmClose();
        setSelectedItems([]);
        setSelectedGroups([]);
        toast.success("Collection shared successfully!", {
          iconTheme: {
            primary: "#4318ff",
            secondary: "#FFFAEE",
          },
        });
      } else {
        toast.error(res?.payload?.message);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleShareWithStudent = (id) => {

  };

  const handleConfirmClose = async () => {
    setModalOpen(false);
  };

  return (
    <>
      <Modal
        size="lg"
        show={show}
        onHide={handleClose}
        className="comn-modal-set add-student-set "
      >
        <Modal.Header className="d-block" style={{ border: "0" }}>
          <Row>
            <Col lg={12} className="d-flex justify-content-center mb-4">
              <div>
                {type === "collectionDetailShareStudent" && (
                  <Modal.Title>Share collection with Learner</Modal.Title>
                )}

                {type === "teacherDetailAddStudent" && (
                  <Modal.Title>Add Learners</Modal.Title>
                )}

                {type === "classDetailAddStudent" && (
                  <Modal.Title>Add Learners to Class</Modal.Title>
                )}

                {type === "classDetailAddStudent" && (
                  <p className="text-center mb-0">
                    Select one or more learners you’d like to add to this class.
                    You can search for learners using the bar below.
                  </p>
                )}

                {type === "existCollectionShareWithLearner" && (
                  <Modal.Title>Share class collection with Learner</Modal.Title>
                )}
              </div>
            </Col>
          </Row>
          <div className="modal-right">
            <button className="menu-dots" onClick={handleClose}>
              <img src={require("../Assets/Images/dotsweb.svg").default}  alt="Menu options" />
            </button>
          </div>
        </Modal.Header>
        <Modal.Body>
          <div className="collection-sec">
            <Row className="justify-content-center">
              <Col lg={8}>
                <SearchBar setSearchValue={setSearchValue} />
              </Col>
            </Row>
            <div className="mt-4">
              {studentData &&
              studentData.student &&
              studentData.student.length > 0 ? (
                <div className="row">
                  <>
                    {studentData.student.map((ele, index) => {
                      return (
                        <>
                          <Col lg={3} key={index}>
                            <div
                              onClick={() => handleClick(ele)}
                              className={
                                selectedItems.includes(ele._id)
                                  ? "active students-list"
                                  : "students-list"
                              }
                              style={{ cursor: "pointer" }}
                            >
                              <img
                                src={
                                  ele?.image
                                    ? ele?.image
                                    : require("../Assets/Images/girl.png")
                                }
                              />
                              
                              {ele?.firstName ? (
                                <h3 className="all-learners-name">
                                  {ele?.firstName} {ele?.surName}
                                </h3>
                              ) : (
                                <h3 className="all-learners-name">N/A</h3>
                              )}
                              {ele?.email && (
                                <abbr
                                  title={ele?.email}
                                  style={{ textDecoration: "none" }}
                                >
                                  <p className="all-learners-mail">
                                    {truncateEmail(ele?.email, 20)}
                                  </p>
                                </abbr>
                              )}
                              {ele?.year && <p>Year {ele?.year}</p>}
                            </div>
                          </Col>
                        </>
                      );
                    })}
                  </>
                </div>
              ) : (
                <div className="data-not-found">
                  <p>No Data Found</p>
                </div>
              )}
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer className="border-none justify-content-center p-4">
          {type === "teacherDetailAddStudent" && (
            <Button
              variant="primary"
              className="modal-f-btn"
              onClick={() => handleAddToTeacher(idval)}
            >
              Add
            </Button>
          )}

          {type === "classDetailAddStudent" && (
            <Button
              variant="primary"
              className="modal-f-btn"
              onClick={() => handleSubmit(idval)}
            >
              Add to Class
            </Button>
          )}

          {type === "existCollectionShareWithLearner" && (
            <Button
              variant="primary"
              className="modal-f-btn"
              onClick={() => handleShareWithStudent(idval)}
            >
              Share
            </Button>
          )}

          {type === "collectionDetailShareStudent" && (
            <Button
              variant="primary"
              className="modal-f-btn"
              onClick={() => handleShareClick(idval)}
            >
              Share
            </Button>
          )}
        </Modal.Footer>
      </Modal>

      <ConfirmModal
        data={{
          collectionId: idval,
          studentId: selectedItems,
        }}
        isModalOpen={isModalOpen}
        selectedType={selectedType}
        handleConfirmClose={handleConfirmClose}
        extraFunction={sensitiveContentShare}
      />
    </>
  );
};

export default StudentsModal;
